import React from 'react';
import { MinHeightProps, BackgroundProps, PaddingProps } from 'styled-system';
import { Box } from './Box';

interface SectionProps extends MinHeightProps, BackgroundProps, PaddingProps {
  children: React.ReactNode;
  id: string;
}

export function Section({ children, id, py = [4, 5], ...rest }: SectionProps) {
  return (
    <Box as="section" id={id} position="relative" py={py} {...rest}>
      {children}
    </Box>
  );
}
